import { updateObject } from "../../shared";
import {
  globalConstants,
  globalSystemConstants,
  loginConstants,
  emptyString,
} from "../../constants";

const { SUCCESS } = globalConstants;
const { GET_ALL_BRANDS_WITH_FEATURE_FLAGS } = loginConstants;
const { SELECTED_ROWS, SPINNER_ACTIVATE, SPINNER_DIACTIVATE } =
  globalSystemConstants;

const initialState = {
  fromHub: { isActive: false, value: emptyString, imagePath: emptyString },
  selectedRows: [],
  spinnerActions: [],
  allBrandsWithFeatureFlags: [],
};

// default reducer i.e. ux manupilation
export const system = (state = initialState, action) => {
  switch (action.type) {
    case SELECTED_ROWS:
      return updateObject(state, { selectedRows: action.data });

    case SPINNER_ACTIVATE:
      return updateObject(state, {
        spinnerActions: [...state.spinnerActions, action.data],
      });

    case SPINNER_DIACTIVATE:
      return updateObject(state, {
        spinnerActions: state.spinnerActions.filter((f) => f !== action.data),
      });
    case globalSystemConstants.SET_FROM_HUB:
      return updateObject(state, {
        fromHub: action.data,
      });

    case GET_ALL_BRANDS_WITH_FEATURE_FLAGS + SUCCESS:
      return updateObject(state, {
        allBrandsWithFeatureFlags: action.data?.features,
      });

    default:
      return state;
  }
};
